module.exports = __webpack_public_path__ + "img/ml.fd1e5572.png";